// ✅ Delegated click handler (handles wishlist toggle + remove)
document.body.addEventListener('click', (e) => {
  // wishlist button (toggle)
  const wishlistBtn = e.target.closest('.wishlist_button');
  if (wishlistBtn) {
    toggleWishlist(e);
    return;
  }
  // remove button inside wishlist (delegated)
  const removeBtn = e.target.closest('.remove-btn');
  if (removeBtn) {
    e.preventDefault(); // prevents accidental form submits or links
    const card = removeBtn.closest('.wishlist-card');
    const variantId = card?.dataset.variantId || removeBtn.dataset.variantId;
    if (variantId) {
      // call the same remove function you already have
      removeFromWishlist(variantId);
    }
  }
});
// =========================
// DOM Content upload
// =========================
document.addEventListener('DOMContentLoaded', () => {
  initWishlistButtons();
  displayWishlist();
  watchVariantChange(document);
  updateWishlistCount(); 
});

// =========================
// DOM CACHE SYSTEM
// =========================
const domCache = new WeakMap();

function getCachedElements(scope) {
  if (domCache.has(scope)) {
    return domCache.get(scope);
  }
  const elements = {
    wishlistButton: scope.querySelector('.wishlist_button'),
    variantInput: scope.querySelector('input[name="id"]'),
    form: scope.querySelector('form')
  };
  domCache.set(scope, elements);
  return elements;
}
// Invalidate cache when Shopify sections reload
document.addEventListener('shopify:section:load', (e) => domCache.delete(e.target));
document.addEventListener('shopify:section:unload', (e) => domCache.delete(e.target));

// =========================
// SAFE STORAGE OPERATIONS (reverted to direct localStorage)
// =========================
function safeGetWishlist() {
  try {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  } catch (error) {
    console.error('Error reading wishlist from localStorage:', error);
    return [];
  }
}

function safeSetWishlist(data) {
  try {
    localStorage.setItem('wishlist', JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Error saving wishlist to localStorage:', error);
    return false;
  }
}

// =========================
// TOGGLE WISHLIST BUTTON (UPDATED, DROP-IN)
// =========================
function toggleWishlist(e) {
  e.stopPropagation();

  const wishlistButton = e.target.closest('.wishlist_button');
  if (!wishlistButton) return;

  // Use cached elements when possible
  const scope = wishlistButton.closest('product-form-component') ||
                wishlistButton.closest('form') ||
                document;

  const cached = getCachedElements(scope);
  const variantInput = cached.variantInput || scope.querySelector('input[name="id"]');
  const selectedVariantId = variantInput?.value || wishlistButton.dataset.variantId;

  if (!selectedVariantId) {
    console.error('Variant ID not found for wishlist');
    return;
  }

  // Normalize and store on the button
  const variantIdStr = String(selectedVariantId);
  wishlistButton.dataset.variantId = variantIdStr;

  // Gather product/variant data (fall back to data-* attrs)
  const selectedVariant = window.product?.variants?.find(v => String(v.id) === variantIdStr);
  const variantImage = selectedVariant?.featured_media?.preview_image?.src || wishlistButton.dataset.productImg;
  const variantTitle = selectedVariant?.title || wishlistButton.dataset.variantTitle || '';

  const pdpData = {
    productId: wishlistButton.dataset.productId,
    variantId: variantIdStr,
    variantTitle,
    productTitle: wishlistButton.dataset.productTitle,
    productImg: variantImage,
    productPrice: wishlistButton.dataset.productPrice,
    productUrl: wishlistButton.dataset.productUrl
  };

  // Read, check, toggle
  let wishlistData = safeGetWishlist();
  const isAlreadyInWishlist = wishlistData.some(item => String(item.variantId) === variantIdStr);
  const fullTitle = variantTitle ? `${variantTitle} - ${pdpData.productTitle}` : pdpData.productTitle;

  if (!isAlreadyInWishlist) {
    // add
    wishlistData.unshift(pdpData);
    wishlistButton.classList.add('wishlisted');
    wishlistButton.innerHTML = getFilledHeartHTML();
    wishlistButton.setAttribute('aria-pressed', 'true');
    wishlistButton.setAttribute('aria-label', `Remove ${fullTitle} from wishlist`);
    showWishlistMessage(`Added ${fullTitle} to Wishlist`, 'green');
  } else {
    // remove
    wishlistData = wishlistData.filter(item => String(item.variantId) !== variantIdStr);
    wishlistButton.classList.remove('wishlisted');
    wishlistButton.innerHTML = getOutlineHeartHTML();
    wishlistButton.setAttribute('aria-pressed', 'false');
    wishlistButton.setAttribute('aria-label', `Add ${fullTitle} to wishlist`);
    showWishlistMessage(`Removed ${fullTitle} from Wishlist`, 'red');
  }

  // Persist
  safeSetWishlist(wishlistData);

  // detailed change event for targeted updates
  const action = isAlreadyInWishlist ? 'removed' : 'added';
  try {
    document.dispatchEvent(new CustomEvent('wishlist:change', {
      detail: { variantId: variantIdStr, action, item: isAlreadyInWishlist ? null : pdpData }
    }));
  } catch (err) {
    console.error('Failed to dispatch wishlist:change', err);
  }
  // general update event (existing listeners use this)
  try {
    document.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { list: wishlistData } }));
  } catch (err) {
    console.error('Failed to dispatch wishlistUpdated', err);
  }
  // Quick header repair: call updateWishlistCount() if present (fast visual feedback)
  if (typeof updateWishlistCount === 'function') {
    try { updateWishlistCount(); } catch (err) { /* ignore */ }
  }
  // Update wishlist page if present
  if (document.querySelector('.js-wishlistBlock')) {
    displayWishlist();
  }
  // Re-init buttons in quick modal if present
  const modalContent = document.getElementById('quick-add-modal-content');
  if (modalContent) {
    setTimeout(() => initWishlistButtons(modalContent), 100);
  }
}
// =========================
// REMOVE FROM WISHLIST (FIXED)
// =========================
function removeFromWishlist(variantId) {
  let wishlistData = safeGetWishlist();
  // Find the item being removed for the toast message
  const removedItem = wishlistData.find(item => item.variantId === variantId);
  const fullTitle = removedItem
    ? (removedItem.variantTitle ? `${removedItem.variantTitle} - ${removedItem.productTitle}` : removedItem.productTitle)
    : 'Product';
  // Remove from storage
  wishlistData = wishlistData.filter(item => item.variantId !== variantId);
  safeSetWishlist(wishlistData);
  // Update UI with animation
  const card = document.querySelector(`.wishlist-card[data-variant-id="${variantId}"]`);
  if (card) {
    card.style.transition = 'all 0.25s ease';
    card.style.opacity = '0';
    card.style.transform = 'scale(0.95)';

    setTimeout(() => {
      card.remove();
      displayWishlist();
    }, 200);
  } else {
    displayWishlist();
  }
  // Dispatch update event
  document.dispatchEvent(new CustomEvent('wishlistUpdated'));
  showWishlistMessage('Product Removed from Wishlist', 'red');
}
// =========================
// DISPLAY WISHLIST ITEMS
// =========================
function displayWishlist() {
  const wishlistData = safeGetWishlist();
  const wishlistBlock = document.querySelector('.js-wishlistBlock');
  const emptyMessage = document.querySelector('.wishlist-empty-message');

  if (!wishlistBlock) return;

  // Handle Empty Wishlist
  if (wishlistData.length === 0) {
    wishlistBlock.innerHTML = `
      <div class="wishlist-empty">
        <div class="wishlist-empty__icon">💔</div>
        <h3>Oof. Wishlist Eliminated</h3>
        <p>Looks like you haven’t saved any fits yet—time to respawn your style.</p>
        <a href="/collections/all" class="button wishlist-empty__cta">Find Your Next Fit</a>
      </div>
    `;
    emptyMessage?.classList.add('hidden');
    return;
  }

  emptyMessage?.classList.add('hidden');

  // Build Wishlist Cards
  const wishlistHtml = wishlistData
    .map(
      (item) => `
    <div class="wishlist-card" data-variant-id="${item.variantId}">
      <button class="remove-btn" title="Remove from wishlist">×</button>

      <a href="${item.productUrl}" class="wishlist-card__image">
        <img src="${item.productImg}" alt="${item.productTitle}" loading="lazy" decoding="async" />
      </a>

      <div class="wishlist-card__info">
        <div class="c-product__title" title="${item.productTitle}">
          ${item.productTitle}
        </div>

        <div class="c-product__price">
          <span class="price-item price-item--regular">${item.productPrice}</span>
        </div>

        <form method="post" action="/cart/add" class="wishlist-form">
          <input type="hidden" name="id" value="${item.variantId}">
          <button type="submit" class="wishlist-atc-button button">
            <span class="wishlist-atc-button__icon-wrapper">👜</span>
            <span class="wishlist-atc-button__text">Add to Loadout</span>
          </button>
        </form>
      </div>
    </div>
  `
    )
    .join('');

  // Render with requestAnimationFrame for smoother load
  requestAnimationFrame(() => {
    wishlistBlock.innerHTML = wishlistHtml;
  });
}

// ✅ Handle Add to Cart animations (native Shopify submission)
function handleWishlistAddToCart(event) {
  const form = event.target.closest('form[action="/cart/add"]');
  if (!form) return;

  const button = form.querySelector('.wishlist-atc-button');
  if (!button) return;

  // Animate button state
  button.classList.add('is-loading');
  button.querySelector('.wishlist-atc-button__text').textContent = 'Adding...';

  // Let Shopify handle add-to-cart natively (don’t preventDefault)
  setTimeout(() => {
    button.classList.remove('is-loading');
    button.classList.add('atc-added');
    button.querySelector('.wishlist-atc-button__text').textContent = 'Added!';

    setTimeout(() => {
      button.classList.remove('atc-added');
      button.querySelector('.wishlist-atc-button__text').textContent = 'Add to Bag';
    }, 900);
  }, 500); // quick feedback
}

// Listen for native Shopify add-to-cart form submits
document.addEventListener('submit', (event) => {
  if (event.target.matches('.wishlist-form')) {
    handleWishlistAddToCart(event);
  }
});
// =========================
// WISHLIST ICON FILLED
// =========================
function getFilledHeartHTML() {
  return `<svg class="heart-filled" width="40px" height="40px" viewBox="0 0 24 24" fill="#fe0215" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#fe0215"/>
  </svg><p class="wishlist_text">Wishlisted</p>`;
}
// =========================
// WISHLIST ICON OUTLINE
// =========================
function getOutlineHeartHTML() {
  return `<svg class="heart-outline" width="40px" height="40px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" fill="none" width="24" height="24"/>
    <g>
      <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>
    </g>
  </svg><p class="wishlist_text">Wishlist</p>`;
}
// =========================
// INIT BUTTONS ON LOAD
// =========================
function initWishlistButtons(scope = document) {
  const wishlistButtons = scope.querySelectorAll('.wishlist_button');
  const wishlistData = safeGetWishlist();

  wishlistButtons.forEach((button) => {
  const variantId = button.dataset.variantId || document.querySelector('form input[name="id"]')?.value;
  const isInWishlist = wishlistData.some(item => item.variantId === variantId);

  button.innerHTML = isInWishlist ? getFilledHeartHTML() : getOutlineHeartHTML();
  button.classList.toggle('wishlisted', isInWishlist);
  button.setAttribute('aria-pressed', isInWishlist ? 'true' : 'false');
  button.setAttribute('aria-label', isInWishlist ? 'Remove from wishlist' : 'Add to wishlist');
});
}
// =========================
// UPDATE WISHLIST BUBBLE
// =========================
function updateWishlistCount() {
  const header = document.querySelector('header');
  const bubble = document.getElementById('wishlist-count');
  const textCount = bubble?.querySelector('.wishlist-bubble__text-count');
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  if (bubble && textCount) {
    if (wishlist.length > 0) {
      textCount.textContent = wishlist.length;
      textCount.classList.remove('hidden');
      bubble.classList.remove('visually-hidden');
      bubble.style.display = 'flex';
    } else {
      textCount.textContent = '';
      textCount.classList.add('hidden');
      bubble.classList.add('visually-hidden');
      bubble.style.display = 'none';
    }
  }
}
document.addEventListener('wishlistUpdated', updateWishlistCount);


document.addEventListener('shopify:section:load', () => {
  setTimeout(updateWishlistCount, 50);
});

// =========================
// UPDATE ALL BUTTON STATES
// =========================
function updateAllWishlistButtons() {
  // 1. Build a Set of Strings once.
  const wishlistIds = new Set(
    safeGetWishlist().map(item => String(item.variantId))
  );

  // 2. Walk the buttons.
  document.querySelectorAll('.wishlist_button').forEach(btn => {
    let id = btn.dataset.variantId;

    // 3. Fallback & cache (exactly like before).
    if (!id) {
      id = btn.closest('form')?.querySelector('input[name="id"]')?.value;
      if (id) btn.dataset.variantId = id;
    }
    if (!id) return;

    // 4. Update UI (same calls as original).
    const on = wishlistIds.has(String(id));   // explicit cast, no ==
    btn.innerHTML = on ? getFilledHeartHTML() : getOutlineHeartHTML();
    btn.classList.toggle('wishlisted', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}
// =========================
// TOAST MESSAGE FOR PDP
// =========================
function showWishlistMessage(message, color = 'green') {
  const toast = document.getElementById('wishlist-toast');
  const messageSpan = toast?.querySelector('.wishlist-toast__message');
  if (!toast || !messageSpan) return;

  messageSpan.textContent = message;
  toast.style.backgroundColor = color === 'green' ? '#22c55e' : '#ef4444';

  clearTimeout(toast.hideTimeout);
  toast.classList.remove('hidden');
  toast.classList.add('show');

  toast.hideTimeout = setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.classList.add('hidden'), 300);
  }, 2000);
}
// =========================
// VARIANT CHANGE WATCH
// =========================
function watchVariantChange(scope = document) {
  const variantInput = scope.querySelector('input[name="id"]');
  if (!variantInput) return;

  // cleanup previous
  if (scope._variantObserver) {
    scope._variantObserver.disconnect();
    scope._variantInterval && clearInterval(scope._variantInterval);
    scope.removeEventListener && scope.removeEventListener('_wl_variant_change');
  }

  let previousVariantId = variantInput.value;

  function handleVariantChange(currentVariantId) {
    if (!currentVariantId) return;
    if (currentVariantId === previousVariantId) return;
    previousVariantId = currentVariantId;
    const wishlistButton = scope.querySelector('.wishlist_button');
    if (wishlistButton) {
      const wishlist = safeGetWishlist();
      const isWishlisted = wishlist.some(item => item.variantId === currentVariantId);
      wishlistButton.innerHTML = isWishlisted ? getFilledHeartHTML() : getOutlineHeartHTML();
      wishlistButton.classList.toggle('wishlisted', isWishlisted);
      wishlistButton.dataset.variantId = currentVariantId;
      // set aria
      wishlistButton.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');
    }
  }

  // 1) listen to input/change (best)
  variantInput.addEventListener('change', () => handleVariantChange(variantInput.value));
  variantInput.addEventListener('input', () => handleVariantChange(variantInput.value));

  // 2) MutationObserver fallback (for themes that change attributes)
  const observer = new MutationObserver(() => handleVariantChange(variantInput.value));
  observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  scope._variantObserver = observer;

  // 3) Very small polling fallback (if theme uses JS-only updates without events)
  scope._variantInterval = setInterval(() => {
    const current = variantInput.value;
    if (current !== previousVariantId) handleVariantChange(current);
  }, 250);
}
